import { PageController } from '@client/components/_core/layout/PageController';
import { PublicNoIndex } from '@client/components/_shared/public/PublicNoIndex';
import { RequireAuth } from '@client/components/auth/RequireAuth';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/attestation')({
    component: AttestationLayout,
});

function AttestationLayout() {
    return (
        <PageController route={Route}>
            <PublicNoIndex />
            <RequireAuth>
                <div className="relative flex h-screen w-screen flex-col justify-start overflow-auto overscroll-contain bg-muted p-4 [scrollbar-gutter:stable] md:py-8">
                    <div className="mx-auto flex w-full max-w-3xl flex-1 flex-col">
                        <Outlet />
                    </div>
                </div>
            </RequireAuth>
        </PageController>
    );
}
